<template>
  <div class="divider">
    <span class="text">
      <template v-if="$slots.text">
        <slot name="text" />
      </template>
      <template v-else>{{ $t('yi-jing-dao-di-la') }}</template>
    </span>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.divider {
  @apply text-14 text-font-60 relative w-full flex items-center justify-center whitespace-nowrap text-center box-border p-0 my-[20px];
  border-block-start: 0 var(--back-4);
  &::before,
  &::after {
    @apply relative box-border;
    content: '';
    width: 25%;
    border-block-start: 1px solid transparent;
    border-block-start-color: inherit;
    border-block-end: 0;
    transform: translateY(25%);
  }

  .text {
    @apply px-[20px] inline-block;
  }
}
</style>
